var map = {
	"./": 309,
	"./fonts/Montserrat/Montserrat-Black.eot": 1006,
	"./fonts/Montserrat/Montserrat-Black.ttf": 1007,
	"./fonts/Montserrat/Montserrat-Black.woff": 1008,
	"./fonts/Montserrat/Montserrat-BlackItalic.eot": 1009,
	"./fonts/Montserrat/Montserrat-BlackItalic.ttf": 1010,
	"./fonts/Montserrat/Montserrat-BlackItalic.woff": 1011,
	"./fonts/Montserrat/Montserrat-Bold.eot": 1012,
	"./fonts/Montserrat/Montserrat-Bold.ttf": 1013,
	"./fonts/Montserrat/Montserrat-Bold.woff": 1014,
	"./fonts/Montserrat/Montserrat-BoldItalic.eot": 1015,
	"./fonts/Montserrat/Montserrat-BoldItalic.ttf": 1016,
	"./fonts/Montserrat/Montserrat-BoldItalic.woff": 1017,
	"./fonts/Montserrat/Montserrat-ExtraBold.eot": 1018,
	"./fonts/Montserrat/Montserrat-ExtraBold.ttf": 1019,
	"./fonts/Montserrat/Montserrat-ExtraBold.woff": 1020,
	"./fonts/Montserrat/Montserrat-ExtraBoldItalic.eot": 1021,
	"./fonts/Montserrat/Montserrat-ExtraBoldItalic.ttf": 1022,
	"./fonts/Montserrat/Montserrat-ExtraBoldItalic.woff": 1023,
	"./fonts/Montserrat/Montserrat-ExtraLight.eot": 1024,
	"./fonts/Montserrat/Montserrat-ExtraLight.ttf": 1025,
	"./fonts/Montserrat/Montserrat-ExtraLight.woff": 1026,
	"./fonts/Montserrat/Montserrat-ExtraLightItalic.eot": 1027,
	"./fonts/Montserrat/Montserrat-ExtraLightItalic.ttf": 1028,
	"./fonts/Montserrat/Montserrat-ExtraLightItalic.woff": 1029,
	"./fonts/Montserrat/Montserrat-Italic.eot": 1030,
	"./fonts/Montserrat/Montserrat-Italic.ttf": 1031,
	"./fonts/Montserrat/Montserrat-Italic.woff": 1032,
	"./fonts/Montserrat/Montserrat-Light.eot": 1033,
	"./fonts/Montserrat/Montserrat-Light.ttf": 1034,
	"./fonts/Montserrat/Montserrat-Light.woff": 1035,
	"./fonts/Montserrat/Montserrat-LightItalic.eot": 1036,
	"./fonts/Montserrat/Montserrat-LightItalic.ttf": 1037,
	"./fonts/Montserrat/Montserrat-LightItalic.woff": 1038,
	"./fonts/Montserrat/Montserrat-Medium.eot": 1039,
	"./fonts/Montserrat/Montserrat-Medium.ttf": 1040,
	"./fonts/Montserrat/Montserrat-Medium.woff": 1041,
	"./fonts/Montserrat/Montserrat-MediumItalic.eot": 1042,
	"./fonts/Montserrat/Montserrat-MediumItalic.ttf": 1043,
	"./fonts/Montserrat/Montserrat-MediumItalic.woff": 1044,
	"./fonts/Montserrat/Montserrat-Regular.eot": 1045,
	"./fonts/Montserrat/Montserrat-Regular.ttf": 1046,
	"./fonts/Montserrat/Montserrat-Regular.woff": 1047,
	"./fonts/Montserrat/Montserrat-SemiBold.eot": 1048,
	"./fonts/Montserrat/Montserrat-SemiBold.ttf": 1049,
	"./fonts/Montserrat/Montserrat-SemiBold.woff": 1050,
	"./fonts/Montserrat/Montserrat-SemiBoldItalic.eot": 1051,
	"./fonts/Montserrat/Montserrat-SemiBoldItalic.ttf": 1052,
	"./fonts/Montserrat/Montserrat-SemiBoldItalic.woff": 1053,
	"./fonts/Montserrat/Montserrat-Thin.eot": 1054,
	"./fonts/Montserrat/Montserrat-Thin.ttf": 1055,
	"./fonts/Montserrat/Montserrat-Thin.woff": 1056,
	"./fonts/Montserrat/Montserrat-ThinItalic.eot": 1057,
	"./fonts/Montserrat/Montserrat-ThinItalic.ttf": 1058,
	"./fonts/Montserrat/Montserrat-ThinItalic.woff": 1059,
	"./fonts/Montserrat/stylesheet.css": 1060,
	"./icons/arrow.svg": 1061,
	"./icons/check-circle-regular.svg": 1062,
	"./icons/clock-regular.svg": 1063,
	"./icons/contact/envelope-solid.svg": 604,
	"./icons/contact/phone-alt-solid.svg": 605,
	"./icons/contact/telegram-solid.svg": 448,
	"./icons/contact/whatsapp-solid.svg": 606,
	"./icons/excel.svg": 1064,
	"./icons/goal/cascade-goal.svg": 1065,
	"./icons/goal/individual-goal.svg": 1066,
	"./icons/goal/library-goal.svg": 1067,
	"./icons/home-page/dictionary-employees.svg": 550,
	"./icons/home-page/vacation-request.svg": 551,
	"./icons/key.svg": 1068,
	"./icons/learningHistory/book-solid.svg": 1069,
	"./icons/learningHistory/chalkboard-teacher-solid.svg": 1070,
	"./icons/learningHistory/comment-alt-regular.svg": 1071,
	"./icons/learningHistory/tasks-solid.svg": 1072,
	"./icons/menu": 247,
	"./icons/menu-blue": 269,
	"./icons/menu-blue/": 269,
	"./icons/menu-blue/absence.svg": 607,
	"./icons/menu-blue/assigment-interview.svg": 608,
	"./icons/menu-blue/books.svg": 609,
	"./icons/menu-blue/calendar.svg": 610,
	"./icons/menu-blue/certificateRequest.svg": 611,
	"./icons/menu-blue/course-catalog.svg": 612,
	"./icons/menu-blue/course-schedule.svg": 613,
	"./icons/menu-blue/courses.svg": 614,
	"./icons/menu-blue/dmc-my.svg": 615,
	"./icons/menu-blue/employee-recognition.svg": 616,
	"./icons/menu-blue/help.svg": 617,
	"./icons/menu-blue/index": 269,
	"./icons/menu-blue/index.tsx": 269,
	"./icons/menu-blue/job-offers.svg": 618,
	"./icons/menu-blue/kpi.svg": 619,
	"./icons/menu-blue/learning-history.svg": 620,
	"./icons/menu-blue/library.svg": 621,
	"./icons/menu-blue/main.svg": 622,
	"./icons/menu-blue/my-app-vacation.svg": 623,
	"./icons/menu-blue/my-books.svg": 624,
	"./icons/menu-blue/my-courses.svg": 625,
	"./icons/menu-blue/my-education.svg": 626,
	"./icons/menu-blue/my-kpi.svg": 627,
	"./icons/menu-blue/my-profile.svg": 628,
	"./icons/menu-blue/my-rating.svg": 629,
	"./icons/menu-blue/my-team.svg": 630,
	"./icons/menu-blue/rating-students.svg": 631,
	"./icons/menu-blue/schedule-offsets.svg": 632,
	"./icons/menu-blue/team-kpi.svg": 633,
	"./icons/menu-blue/team-rating.svg": 634,
	"./icons/menu-blue/trainingPlan.svg": 635,
	"./icons/menu-blue/vacation.svg": 636,
	"./icons/menu/": 247,
	"./icons/menu/absence.svg": 552,
	"./icons/menu/adaptationPlan.forNewEmployee.svg": 553,
	"./icons/menu/allRequests.svg": 554,
	"./icons/menu/annual-salary-revision.svg": 555,
	"./icons/menu/assigment-interview.svg": 556,
	"./icons/menu/assistant-team.svg": 557,
	"./icons/menu/awards.svg": 558,
	"./icons/menu/books.svg": 559,
	"./icons/menu/calendar.svg": 560,
	"./icons/menu/certificateRequest.svg": 561,
	"./icons/menu/concourse.svg": 562,
	"./icons/menu/course-catalog.svg": 563,
	"./icons/menu/courses.svg": 564,
	"./icons/menu/dictionaryEmployees.svg": 565,
	"./icons/menu/dmc-my.svg": 566,
	"./icons/menu/documentsFamiliarization.svg": 567,
	"./icons/menu/employee-recognition.svg": 568,
	"./icons/menu/help.svg": 569,
	"./icons/menu/hr-request-manager.svg": 570,
	"./icons/menu/incentive.svg": 571,
	"./icons/menu/index": 247,
	"./icons/menu/index.tsx": 247,
	"./icons/menu/job-offers.svg": 572,
	"./icons/menu/kpi.svg": 573,
	"./icons/menu/learn-history.svg": 574,
	"./icons/menu/learning-budget.svg": 575,
	"./icons/menu/library.svg": 576,
	"./icons/menu/main.svg": 577,
	"./icons/menu/manager-vacancies.svg": 578,
	"./icons/menu/menu-nine-box.svg": 579,
	"./icons/menu/menuCba.svg": 580,
	"./icons/menu/my-app-vacation.svg": 581,
	"./icons/menu/my-books.svg": 582,
	"./icons/menu/my-courses.svg": 583,
	"./icons/menu/my-education.svg": 584,
	"./icons/menu/my-profile.svg": 585,
	"./icons/menu/my-rating.svg": 586,
	"./icons/menu/my-team.svg": 587,
	"./icons/menu/orgStructureRequest.svg": 588,
	"./icons/menu/organization.vacancies.svg": 589,
	"./icons/menu/personPayslip.svg": 590,
	"./icons/menu/position-hierarchy.svg": 591,
	"./icons/menu/questionnaire.svg": 592,
	"./icons/menu/recognition.svg": 593,
	"./icons/menu/schedule-offsets.svg": 594,
	"./icons/menu/store.svg": 595,
	"./icons/menu/surCharge.svg": 596,
	"./icons/menu/talentPool.svg": 597,
	"./icons/menu/team-rating.svg": 598,
	"./icons/menu/vacancyRequest.svg": 599,
	"./icons/menu/vacancyRequestAssistant.svg": 600,
	"./icons/menu/vacation.svg": 601,
	"./icons/menu/vacationSchedule.svg": 602,
	"./icons/menu/vacationScheduleMenu.svg": 603,
	"./icons/online.png": 447,
	"./icons/recognition/coins.png": 449,
	"./icons/recognition/medal-bl.png": 637,
	"./icons/recognition/medal-br.png": 638,
	"./icons/recognition/medal-g.png": 639,
	"./icons/recognition/medal-s.png": 640,
	"./icons/recognition/points.png": 641,
	"./icons/uco.png": 464,
	"./icons/user/user-add.svg": 450,
	"./icons/user/user-edit-solid.svg": 642,
	"./icons/user/user-group-add.svg": 451,
	"./img/IPRMainPage.PNG": 443,
	"./img/arrow-down.svg": 546,
	"./img/bell.svg": 547,
	"./img/default-avatar.svg": 267,
	"./img/default-user.svg": 347,
	"./img/lines.png": 444,
	"./img/my-team-person-logo.jpg": 445,
	"./img/no-image.svg": 548,
	"./img/tdc_logo.png": 446,
	"./index": 309,
	"./index.tsx": 309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1005;